import React, { useEffect } from "react";
import ReactLoading from "react-loading";
const Loader = (props) => {
  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);
  return (
    <div
      className="modalBackground"
      // style={{
      //   position: "fixed",
      //   width: "100vw",
      //   height: "100vh",
      //   backgroundColor: "#e0e0e0",
      // }}
    >
      {" "}
      <div
        style={{
          position: "fixed",
          overflow: "hidden",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <ReactLoading
          type={"spokes"}
          color={"#030066"}
          height={"150px"}
          width={"150px"}
        />
      </div>
    </div>
  );
};
export default Loader;
